const constant = {
  APIURL: 'https://gank.io/api/'
}

export default constant



// WEBPACK FOOTER //
// ./src/common/constant.js